import {OfficeState, OfficeTypes} from "./actionsTypes";

export const INIT_STATE: OfficeState = {
    data: [],

    pagination: {},
    error: {},
    loading: false,
    loaded: false,

    isOpenModal: false,
}

const office = (state = INIT_STATE, action: any) => {
    switch (action.type) {
        case OfficeTypes.GET_OFFICES:
            return {
                ...state,
                loading: true
            }

        case OfficeTypes.GET_OFFICES_SUCCESS:
            return {
                ...state,
                data: action.payload.data,
                pagination: action.payload.pagination,
                loaded: true,
                loading: false
            }

        case OfficeTypes.ADD_OFFICE_SUCCESS:
            return {
                ...state,
                data: [action.payload, ...state.data],
            }

        case OfficeTypes.FAIL_OFFICES:
            return {
                ...state,
                error: action.payload,
                loaded: false,
                loading: false
            }

        case OfficeTypes.CLEAR_OFFICES:
            return INIT_STATE;

        case OfficeTypes.MODAL_OFFICE:
            return {
                ...state,
                isOpenModal: action.status,
            }

        default:
            return state
    }
}

export default office